import { useState } from 'react';
import {
  getCoreRowModel,
  getPaginationRowModel,
  useReactTable,
  ColumnDef,
  Table,
} from '@tanstack/react-table';
import { CommonFetchService } from '../services/CommonFetchService';

type UsePaginatedTableOptions<T> = {
  url: string;
  columns: ColumnDef<T, any>[];
  initialPageIndex?: number;
  pageSize?: number;
};

type UsePaginatedTableResult<T> = {
  table: Table<T>;
  loading: boolean;
  error: Error | null;
};

export function usePaginatedTable<T>({
  url,
  columns,
  initialPageIndex = 0,
  pageSize = 10,
}: UsePaginatedTableOptions<T>): UsePaginatedTableResult<T> {
  const [pagination, setPagination] = useState({
    pageIndex: initialPageIndex,
    pageSize: pageSize,
  });

  type DataResponse = {
    data: T[];
    totalPages: number;
  };

  const { data, loading, error } = CommonFetchService<DataResponse>(
    `index.cgi?path=${url}&page=${pagination.pageIndex + 1}&limit=${pagination.pageSize}`
  );

  const table = useReactTable({
    data: data?.data ?? [],
    columns,
    pageCount: data?.totalPages,
    manualPagination: true,
    state: {
      pagination,
    },
    onPaginationChange: setPagination,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
  });

  return { table, loading, error };
}
